var _rect, _rect2, _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKoFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -4 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_3460)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_503_3460",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_503_3460)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14.6667C16.5773 14.6667 18.6667 12.5773 18.6667 10C18.6667 7.42268 16.5773 5.33334 14 5.33334C11.4227 5.33334 9.33334 7.42268 9.33334 10C9.33334 12.5773 11.4227 14.6667 14 14.6667Z",
    fill: "#E01B41"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_503_3460",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 5,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14.6667C16.5773 14.6667 18.6667 12.5773 18.6667 10C18.6667 7.42268 16.5773 5.33334 14 5.33334C11.4227 5.33334 9.33334 7.42268 9.33334 10C9.33334 12.5773 11.4227 14.6667 14 14.6667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_503_3460)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33335 10.6667C10.6667 11.9167 12.6667 12.6667 14 10.6667C15.3333 8.66669 18 8.66669 18.6667 10.6667C19.3333 12.6667 18.6667 14.6667 18.6667 14.6667H9.33335C9.33335 14.6667 8.00001 9.41669 9.33335 10.6667Z",
    fill: "#0E4B9C"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17308 3.55661C6.26513 3.39718 6.46899 3.34256 6.62842 3.43461L7.20577 3.76794C7.3652 3.85999 7.41983 4.06385 7.32778 4.22328L5.66111 7.11003C5.56907 7.26946 5.3652 7.32409 5.20577 7.23204L4.62842 6.89871C4.46899 6.80666 4.41437 6.6028 4.50641 6.44337L6.17308 3.55661ZM20.7942 3.76794C20.6348 3.85999 20.5802 4.06385 20.6722 4.22328L22.3389 7.11003C22.4309 7.26946 22.6348 7.32409 22.7942 7.23204L23.3716 6.89871C23.531 6.80666 23.5856 6.6028 23.4936 6.44337L21.8269 3.55661C21.7349 3.39718 21.531 3.34256 21.3716 3.43461L20.7942 3.76794ZM19.0622 4.76794C18.9027 4.85999 18.8481 5.06385 18.9402 5.22328L20.6068 8.11003C20.6989 8.26946 20.9027 8.32409 21.0622 8.23204L21.6395 7.89871C21.799 7.80666 21.8536 7.6028 21.7615 7.44337L20.0949 4.55661C20.0028 4.39718 19.799 4.34256 19.6395 4.43461L19.0622 4.76794ZM4.50641 13.5566C4.41437 13.3972 4.46899 13.1933 4.62842 13.1013L5.20577 12.7679C5.3652 12.6759 5.56907 12.7305 5.66111 12.8899L7.32778 15.7767C7.41983 15.9361 7.3652 16.14 7.20577 16.232L6.62842 16.5654C6.46899 16.6574 6.26513 16.6028 6.17308 16.4434L4.50641 13.5566ZM6.36047 12.1013C6.20104 12.1933 6.14642 12.3972 6.23847 12.5566L7.90513 15.4434C7.99718 15.6028 8.20104 15.6574 8.36047 15.5654L8.93782 15.232C9.09725 15.14 9.15188 14.9361 9.05983 14.7767L7.39317 11.8899C7.30112 11.7305 7.09725 11.6759 6.93782 11.7679L6.36047 12.1013ZM20.6068 11.8899C20.6989 11.7305 20.9027 11.6759 21.0622 11.7679L21.6395 12.1013C21.799 12.1933 21.8536 12.3972 21.7615 12.5566L20.0949 15.4434C20.0028 15.6028 19.799 15.6574 19.6395 15.5654L19.0622 15.232C18.9027 15.14 18.8481 14.9361 18.9402 14.7767L20.6068 11.8899ZM22.7942 12.7679C22.6348 12.6759 22.4309 12.7305 22.3389 12.8899L20.6722 15.7767C20.5802 15.9361 20.6348 16.14 20.7942 16.232L21.3716 16.5654C21.531 16.6574 21.7349 16.6028 21.8269 16.4434L23.4936 13.5566C23.5856 13.3972 23.531 13.1933 23.3716 13.1013L22.7942 12.7679ZM8.36047 4.43461C8.20104 4.34256 7.99718 4.39718 7.90513 4.55661L6.23846 7.44337C6.14642 7.6028 6.20104 7.80666 6.36047 7.89871L6.93782 8.23204C7.09725 8.32409 7.30112 8.26946 7.39317 8.11003L9.05983 5.22328C9.15188 5.06385 9.09725 4.85999 8.93782 4.76794L8.36047 4.43461Z",
    fill: "#262626"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_3460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoFlag);
export default __webpack_public_path__ + "static/media/koFlag.1f779199cd0446828c4206faf8a8e656.svg";
export { ForwardRef as ReactComponent };